import { ReactNode } from 'react';
import { LinkTrackingData } from '../../../../../../AnalyticsContext/LinkTracking';
import { renderLinkTrackingAttributes } from '../../../../../../AnalyticsContext/renderLinkTrackingAttributes';
import {
  Container,
  Descriptor,
  Visual,
  PracticeVisual,
  SpecialtyVisual,
} from './SuggestionTemplate.styles';

interface Props {
  visual: ReactNode;
  primary: ReactNode;
  secondary?: ReactNode;
  trackingData: LinkTrackingData;
  showPracticeVisual?: boolean;
  showSpecialtyIcon?: boolean;
}

export const SuggestionTemplate = ({
  visual,
  primary,
  secondary,
  trackingData,
  showPracticeVisual,
  showSpecialtyIcon,
}: Props) => (
  <Container {...renderLinkTrackingAttributes(trackingData)}>
    {!showPracticeVisual && !showSpecialtyIcon && <Visual>{visual}</Visual>}
    {!showPracticeVisual && showSpecialtyIcon && <SpecialtyVisual>{visual}</SpecialtyVisual>}
    {showPracticeVisual && <PracticeVisual>{visual}</PracticeVisual>}
    <Descriptor>
      <div>{primary}</div>
      {secondary && <div>{secondary}</div>}
    </Descriptor>
  </Container>
);
